import { getSpaceSlugPathQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy module-detail URL. Redirects to `/programs/{program}/{module}`.
 */
export const Route = createFileRoute('/_protected/community-hub/spaces/$id/modules/$moduleId/')({
  beforeLoad: async ({ params }) => {
    const path = await queryClient.ensureQueryData(getSpaceSlugPathQueryOptions(params.moduleId));
    throw redirect({
      to: '/programs/$programSlug/$moduleSlug',
      params: { programSlug: path.programSlug, moduleSlug: path.moduleSlug ?? '' },
      replace: true,
    });
  },
});
